<div class="card">
  <div class="card-header">
    <h4>Packers & Movers Requests</h4>
  </div>

  <div class="card-body">

    <table class="table table-bordered table-striped">
      <thead>
        <tr>
          <th>PM ID</th>
          <th>Name</th>
          <th>Mobile</th>
          <th>Pickup</th>
          <th>Drop</th>
          <th>Request Type</th>
          <th>Moving Date</th>
          <th>Payment Status</th>
          <th>Actions</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let item of allPackersMovers">
          <td>{{item.pmId}}</td>
          <td>{{item.name}}</td>
          <td>{{item.mobile}}</td>
          <td>{{item.pickupLocation}}</td>
          <td>{{item.dropLocation}}</td>
          <td>{{item.requestType}}</td>
          <td>{{item.movingDate}}</td>

          <td>
            <span *ngIf="item.paymentDetails?.status == 0">
              Pending
            </span>

            <span *ngIf="item.paymentDetails?.status == 1">
              Paid
            </span>

            <span *ngIf="item.paymentDetails?.status == 2">
              Partial
            </span>

            <span *ngIf="item.paymentDetails?.status == 3">
              Failed
            </span>
          </td>
           <td>
            <button
              class="btn btn-info btn-sm"
              (click)="viewDetails(item._id)"
            >
              View Details
            </button>
          </td>
        </tr>

        <tr *ngIf="allPackersMovers.length === 0">
          <td colspan="8" class="text-center">
            No Records Found
          </td>
        </tr>
      </tbody>
    </table>

    <div class="mt-3">
      <button
        class="btn btn-primary"
        [disabled]="page === 1"
        (click)="changePage(page - 1)">
        Previous
      </button>

      <span class="mx-3">
        Page {{page}} of {{totalPages}}
      </span>

      <button
        class="btn btn-primary"
        [disabled]="page >= totalPages"
        (click)="changePage(page + 1)">
        Next
      </button>
    </div>

  </div>
</div>